import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useThemeMode } from '../../contexts/ThemeModeContext';
import { useT } from '../../i18n/useT';

export default function MarketingThemeToggle() {
  const t = useT();
  const { mode, setPreference } = useThemeMode();
  const dark = mode === 'dark';

  return (
    <button
      type="button"
      className="landing-theme-toggle"
      aria-label={dark ? t('waitlistThemeLightAria') : t('waitlistThemeDarkAria')}
      aria-pressed={dark}
      data-theme-mode={mode}
      onClick={() => setPreference(dark ? 'light' : 'dark')}
    >
      {dark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
    </button>
  );
}
